export default {
  default: () => import("/vercel/path0/nuxt/layouts/default.vue").then(m => m.default || m)
}